export class EngineRpcError extends Error {
    code;
    data;
    constructor(message, code, data = null) {
        super(message);
        this.code = code;
        this.data = data;
        this.name = "EngineRpcError";
    }
}
export const ENGINE_ERROR_CODES = {
    methodNotFound: -32601,
    invalidParams: -32602,
    internal: -32603,
    notInitialised: -32000,
    notFound: -32004,
    duplicateLookup: -32010, // data: { contactIds: Id[] }
    conflict: -32009,
};
//# sourceMappingURL=rpc.js.map